import {kebabCase} from 'lodash-es';
import type {Gsoa_ProductCatalog_ProductDetail as ProductDetail} from '~/openapi';

export const formatProductSlug = (name?: string, vanr?: string | null): string => {
	const parts = [name, vanr].filter(Boolean);
	return kebabCase(parts.join('-'));
};

export const createHouseProductSlug = (product: ProductDetail): string =>
	formatProductSlug(product.name, product.vanr);
